import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { moduleServerApi } from "../services";

const initialState = {
  menuItems: null,
  allQuestionAnswered: []
};

const moduleSlice = createSlice({
  name: "moduleState",
  initialState,
  reducers: {
    moduleMenu: (state, action) => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        moduleServerApi.endpoints.getTrainingMenuBasedOnModule.matchFulfilled
      ), //updated
      (state, { payload = {} }) => {
        state.menuItems = payload?.menus;
      }
    );
    builder.addMatcher(
      isAnyOf(moduleServerApi.endpoints.bookmarkModule.matchFulfilled), //updated
      (state, { payload = {} }) => {
        state.menuItems = payload?.menus;
      }
    );
    builder.addMatcher(
      isAnyOf(moduleServerApi.endpoints.getAllQuestionAnswer.matchFulfilled), //updated
      (state, { payload = {} }) => {
        state.allQuestionAnswered = payload;
      }
    );
  },
});

export const { moduleMenu } = moduleSlice.actions;

export default moduleSlice.reducer;
